import { Component, Host, h, Prop, Listen, State } from '@stencil/core';
import { $$$ } from '../../../utils/utils';

@Component({
  tag: 'lilu-back-to-top',
  styleUrl: 'lilu-back-to-top.scss',
  shadow: true,
})
export class LiluBackToTop {
  @Prop() text: string;
  @Prop() lastPositionY?: number = 0;
  @Prop() debounce?: any = null;
  @Prop() scrollingTop?: boolean = false;
  @State() shown = false;
  @State() withWKBanner = false;

  @Listen('scroll', { target: 'window' })
  onScroll(e: any) {
    this.withWKBanner = document.querySelector('lilu-add-to-cart')?.shadowRoot?.querySelector('.show') ? true : false;
    let posY: number;
    if (e.currentTarget) {
      posY = e.currentTarget.pageYOffset;
    }
    if (this.debounce !== null) {
      clearTimeout(this.debounce);
      this.debounce = null;
    }

    this.debounce = window.setTimeout(() => {
      this.handleShowState(posY);
      this.debounce = null;
    }, 200);
  }

  handleShowState = (posY: number) => {
    const $guuru = $$$('.guuru')[0];
    const $GuuruMain = $$$('#GuuruMain')[0];
    let positionY = posY;

    if (positionY < this.lastPositionY) {
      if (this.scrollingTop !== true) {
        if ($guuru !== undefined) {
          $guuru.classList.add('backtotop');
        }
        if ('Guuru' in window) {
          $GuuruMain.classList.add('backtotop');
        }
        this.shown = true;
      }
    } else {
      this.scrollingTop = false;
      if ($guuru !== undefined) {
        $guuru.classList.remove('backtotop');
      }
      if ('Guuru' in window) {
        $GuuruMain.classList.remove('backtotop');
      }
      this.shown = false;
    }
    if (positionY === 0) {
      if ($guuru !== undefined) {
        $guuru.classList.remove('backtotop');
      }
      if ('Guuru' in window) {
        $GuuruMain.classList.remove('backtotop');
      }
      this.shown = false;
    }
    this.lastPositionY = positionY;
  };

  scrollTop = () => {
    const $guuru = $$$('.guuru')[0];
    const $GuuruMain = $$$('#GuuruMain')[0];

    this.scrollingTop = true;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if ($guuru !== undefined) {
      $guuru.classList.remove('backtotop');
    }
    if ('Guuru' in window) {
      $GuuruMain.classList.remove('backtotop');
    }
    this.shown = false;
  };

  renderAppearance = () => {
    return `backtotop${this.shown ? ' show' : ''}`;
  };

  render() {
    return (
      <Host class={this.withWKBanner ? 'with-wk-banner' : ''}>
        <div class={this.renderAppearance()}>
          <lilu-button type="primary" height="h-sm" width="w-fit-content" font="regular" fontsize="size-14 lg-size-16" transform="lowercase" onClick={() => this.scrollTop()}>
            <lilu-icon slot="start" size="lg-size" color="white" type="icon-chevron-up"></lilu-icon>
            {this.text}
          </lilu-button>
        </div>
      </Host>
    );
  }
}
